const tabChange = {
    state : {
      tab : ''
    },
    mutations : {
      UPDATE_TAB (state,tab){
        state.tab = tab;
      }
    },
    actions : {
        UPDATE_TAB({ commit },tab){
            commit('UPDATE_TAB',tab);
      }
    }
  }
  
  export default tabChange;
  


// WEBPACK FOOTER //
// ./src/store/modules/tabChange.js